<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_202_629)">
    <path
      d="M10.0087 18.5282C9.49616 18.5282 9.18575 18.5269 8.95501 18.5004C8.74678 18.4764 8.69651 18.4403 8.67884 18.4275C8.66118 18.4146 8.61144 18.3777 8.52494 18.1868C8.4291 17.9753 8.33285 17.6802 8.17603 17.1922L6.61633 12.3388C6.46129 11.8564 6.36873 11.5641 6.32373 11.339C6.28313 11.1359 6.30152 11.0774 6.30823 11.0567C6.31494 11.0359 6.33433 10.9778 6.48626 10.837C6.65468 10.681 6.90102 10.4984 7.30941 10.1984L11.3604 7.22279C11.7764 6.9172 12.0293 6.73314 12.2325 6.61719C12.4159 6.51253 12.4781 6.51211 12.5 6.51211C12.5219 6.51211 12.5841 6.51253 12.7675 6.61719C12.9707 6.73313 13.2236 6.9172 13.6396 7.22279L17.6906 10.1984C18.099 10.4984 18.3453 10.681 18.5137 10.837C18.6657 10.9778 18.6851 11.0359 18.6918 11.0567C18.6985 11.0774 18.7169 11.1359 18.6763 11.339C18.6313 11.5641 18.5387 11.8564 18.3837 12.3388L16.824 17.1922C16.6672 17.6802 16.5709 17.9753 16.4751 18.1868C16.3886 18.3777 16.3388 18.4146 16.3212 18.4275C16.3035 18.4403 16.2532 18.4764 16.045 18.5004C15.8143 18.5269 15.5038 18.5282 14.9913 18.5282H10.0087Z"
      stroke="currentColor"
      stroke-width="1.75"
    />
  </g>
  <defs>
    <clipPath id="clip0_202_629">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
